/* ============================================================
   Llorrea — cijfers laten optellen zodra ze in beeld komen
   Telt eenmalig, niet bij elke keer scrollen.
   ============================================================ */
(function(){

  function run(el){
    if(el.dataset.lloCounted === '1') return;
    el.dataset.lloCounted = '1';

    var target = parseFloat(el.getAttribute('data-to'));
    if(isNaN(target)) return;
    var dur = parseInt(el.getAttribute('data-dur'), 10) || 1600;
    var suffix = el.getAttribute('data-suffix') || '';
    var prefix = el.getAttribute('data-prefix') || '';
    var dec = parseInt(el.getAttribute('data-dec'), 10) || 0;

    var start = null;

    function frame(t){
      if(start === null) start = t;
      var p = (t - start) / dur;
      if(p > 1) p = 1;
      var eased = 1 - Math.pow(1 - p, 3);
      var val = target * eased;
      el.textContent = prefix + val.toFixed(dec) + suffix;
      if(p < 1) window.requestAnimationFrame(frame);
      else el.textContent = prefix + target.toFixed(dec) + suffix;
    }

    window.requestAnimationFrame(frame);
  }

  function boot(){
    var nums = document.querySelectorAll('[data-llo-count]');
    if(!nums.length) return;

    if(!('IntersectionObserver' in window)){
      for(var i = 0; i < nums.length; i++) run(nums[i]);
      return;
    }

    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(e){
        if(e.isIntersecting){
          run(e.target);
          io.unobserve(e.target);
        }
      });
    }, { threshold: 0.35 });

    for(var j = 0; j < nums.length; j++){
      if(nums[j].dataset.lloCounted !== '1') io.observe(nums[j]);
    }
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  window.addEventListener('load', boot);
  document.addEventListener('shopify:section:load', function(){ setTimeout(boot, 60); });
})();
